import config from "../../../src/config.json";
import CryptoJS from "crypto-js";
const encryptionKey = config.encryptionKey;
const encryptionVI = config.encryptionVI;

export const encryptMessage = (plaintext) => {
  const key = CryptoJS.enc.Utf8.parse(encryptionKey); // Must be 16 chars for AES-128
  const iv = CryptoJS.enc.Utf8.parse(encryptionVI);
  const encrypted = CryptoJS.AES.encrypt(plaintext, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  // Convert to hex string to match C# encoding
  return encrypted.ciphertext.toString(CryptoJS.enc.Hex);
};

export const decryptMessage = (cipherHex) => {
  const key = CryptoJS.enc.Utf8.parse(encryptionKey); // Must be 16 chars for AES-128
  const iv = CryptoJS.enc.Utf8.parse(encryptionVI);
  const cipherParams = CryptoJS.lib.CipherParams.create({
    ciphertext: CryptoJS.enc.Hex.parse(cipherHex),
  });

  const decrypted = CryptoJS.AES.decrypt(cipherParams, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  return decrypted.toString(CryptoJS.enc.Utf8);
};

export const commonService = {
  decryptMessage,
  encryptMessage,
};
